import React from "react";

function LegacyWebsite() {
	return (
		<div style={{ backgroundColor: "#21aac1", color: "white", textAlign: "center", padding: "5px" }}>
			You are viewing a legacy version of our website. Please visit{" "}
			<a style={{ color: "white", fontWeight: "bold" }} href="https://www.kingstoncrc.org.au/" rel="noreferrer noopener">
				www.kingstoncrc.org.au
			</a>{" "}
			for the latest information about our church.
		</div>
	);
}

export default LegacyWebsite;
